import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '@/helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL + 'badge/';

class BadgeService {
    getClientBadges(search = null) {
        return axios.get(API_URL + 'getclientbadges/' + UserHelper.getClientId(),
        {
            params: { search: search },
            headers: authHeader()
        });
    }

    getClientBadgeProfiles() {
        return axios.get(API_URL + 'getclientbadgeprofiles/' + UserHelper.getClientId(), { headers: authHeader() });
    }

    getProfile(id) {
        return axios.get(API_URL + 'getbadgeprofile/' + id, { headers: authHeader() });
    }

    getBadge(id) {
        return axios.get(API_URL + 'getbadge/' + id, { headers: authHeader() });
    }

    getBadgeByNumber(number) {
        return axios.get(API_URL + 'getbadgebynumber/' + number, { headers: authHeader() });
    }

    createProfile(name) {
        return axios.put(API_URL + 'createclientbadgeprofile/' + UserHelper.getClientId(), {
            name: name
        },
        { headers: authHeader() });
    }

    updateBadge(data) {
        return axios.put(API_URL + 'updatebadge/' + UserHelper.getClientId(), data, { headers: authHeader() });
    }

    updateProfile(data) {
        return axios.put(API_URL + 'updatebadgeprofile/' + UserHelper.getClientId(), data, { headers: authHeader() });
    }

    saveProfileBalises(id, data) {
        return axios.put(API_URL + 'updateprofilebalises/' + id, {
            balises: data
        },
        { headers: authHeader() });
    }

    deleteProfile(id) {
        return axios.delete(API_URL + 'deletebadgeprofile/' + id, { headers: authHeader() });
    }
}

export default new BadgeService();